import {Footer} from "./Footer";
import {Header} from "./Header";
// Layout component that includes header and footer
function Layout1({ children }) {
  return (
    <div className="flex flex-col min-h-screen font-sans">
      <Header/>
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
    </div>
  );
}
export {Layout1};